import { render, staticRenderFns } from "./Onglets_Overview.vue?vue&type=template&id=8ddf5f40&"
import script from "./Onglets_Overview.vue?vue&type=script&lang=js&"
export * from "./Onglets_Overview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports